import type { FC, ReactElement } from 'react'
import { Skeleton as AntdSkeleton } from 'antd'


interface T_SkeletonProps {
  count: number
  title?: boolean
}

export const Skeleton: FC<T_SkeletonProps> = ({
  count,
  title = true,
}) => {
  const skeletons: ReactElement[] = []

  for (let i = 0; i < count; i++) {
    skeletons.push(<AntdSkeleton active key={Math.random()} title={title} />)
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
      {skeletons}
    </div>
  )
}
